import { UcoastEl } from '@/scripts/core/UcoastEl'
import {
	currentTargetRequired,
	getAttributeOrThrow,
	qsaRequired,
	qsRequired,
	removeTrapFocus,
	trapFocus,
} from '@/scripts/core/global'

export class UcoastSelect extends UcoastEl {
	static htmlSelector = 'ucoast-select'
	select: HTMLSelectElement
	optionButtons: NodeListOf<HTMLButtonElement>
	optionPanel: HTMLElement
	closeListener: (e: MouseEvent) => void
	triggerEl: HTMLButtonElement | HTMLSelectElement

	constructor() {
		super()
		this.select = qsRequired('select', this)
		this.optionButtons = qsaRequired('button[data-value]', this)
		this.optionPanel = qsRequired('[data-option-panel]', this)
		this.triggerEl = qsRequired('[data-trigger]', this)
		this.triggerEl.addEventListener('click', this.openOptions.bind(this))
		this.select.addEventListener('change', this.onChange.bind(this))
		this.optionButtons.forEach((button) => {
			button.addEventListener('click', (e) => {
				const currentTarget = currentTargetRequired(e)
				const value = getAttributeOrThrow('data-value', currentTarget)
				this.setValue(value)
				const label = qsRequired('span', currentTarget).innerHTML
				this.setLabel(label)
				this.updateActiveClasses(value)
			})
		})
		this.closeListener = this.handleOutsideClick.bind(this)
		this.triggerEl.setAttribute('aria-haspopup', 'dialog')
		this.triggerEl.setAttribute('aria-expanded', 'false')
	}

	onChange(event: Event) {
		const el = event.target as HTMLSelectElement
		const value = el.value
		const eventChange = new CustomEvent('change', {
			detail: { value },
			bubbles: true,
		})
		this.dispatchEvent(eventChange)
	}

	openOptions() {
		if (this.triggerEl.getAttribute('aria-expanded') === 'true') {
			this.closeOptions()
			return
		}
		this.optionPanel.setAttribute('aria-hidden', 'false')
		this.triggerEl.setAttribute('aria-expanded', 'true')
		document.body.addEventListener('click', this.closeListener)
		trapFocus(this.optionPanel)
	}

	closeOptions() {
		this.optionPanel.classList.remove('open')
		this.optionPanel.setAttribute('aria-hidden', 'true')
		this.triggerEl.setAttribute('aria-expanded', 'false')
		document.body.removeEventListener('click', this.closeListener)
		removeTrapFocus(this.triggerEl)
	}

	handleOutsideClick(event: MouseEvent) {
		if (!this.contains(event.target as Node)) {
			this.closeOptions()
		}
	}
	setLabel(label: string) {
		const labelEl = qsRequired('[data-label]', this)
		labelEl.innerHTML = label
	}

	updateActiveClasses(value: string) {
		this.optionButtons.forEach(el => {
			const currentVal = getAttributeOrThrow('data-value', el)
			if (currentVal === value) {
				el.classList.remove('underline-on-hover-child')
				el.classList.add('underline-always-child')
				el.setAttribute('data-selected', '')
			} else {
				el.classList.remove('underline-always-child')
				el.classList.add('underline-on-hover-child')
				el.removeAttribute('data-selected')
			}
		})
	}

	setValue(value: string) {
		if (this.select.value !== value) {
			this.select.value = value
			const event = new Event('change', { bubbles: true })
			this.select.dispatchEvent(event)
		}
		this.closeOptions()
	}
}
